export default function Panel(props: any) {
  const { children, className, ...rest } = props;
  return (
    <div className={`panel ${className || ''}`} {...rest}>
      {children}
    </div>
  );
}
